import { render } from "./HeroiconsOutlineChevronDown.vue?vue&type=template&id=2c607ac2"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDown.vue"]])

export default __exports__